import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, transferConfirmedPickActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, transferConfirmedPickActions);

export default slice.reducer;
